import { Component } from '@angular/core';

@Component({
    selector: 'acad-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less' ]
})
export class AppComponent { }
